/**
 * Get the dimensions of an element, even if it it hidden.
 * Get the natural dimensions of an element (when no inline height/width is set).
 */

define('libs/utilities.element.getDimensions',[],function() {

    'use strict';

    /*
     * @param {Element} element The element to measure.
     * @param {Boolean} natural Get the natural height and width of the element,
     *     with no height or width styles properties set.
     * @return {Object} The inner and outer-dimensions of the element.
     */
    return function(element, natural) {
        if (!(element instanceof jQuery)) {
            element = $(element);
        }
        var display = element.css('display'),
            borderTop = parseInt(element.css('border-top-width')) || 0,
            borderLeft = parseInt(element.css('border-left-width')) || 0,
            borderRight = parseInt(element.css('border-right-width')) || 0,
            borderBottom = parseInt(element.css('border-bottom-width')) || 0,
            paddingTop = parseInt(element.css('padding-top')) || 0,
            paddingLeft = parseInt(element.css('padding-left')) || 0,
            paddingRight = parseInt(element.css('padding-right')) || 0,
            paddingBottom = parseInt(element.css('padding-bottom')) || 0,
            isBorderbox = element.css('box-sizing') == 'border-box';

        if (natural) {
            // store the inline styles on the element so we can restore them after calculating.
            var natural_dim = {
                'height': element[0].style.height,
                'max-height': element[0].style.maxHeight,
                'min-height': element[0].style.minHeight,
                'width': element[0].style.width,
                'max-width': element[0].style.maxWidth,
                'min-width': element[0].style.minWidth
            };

            // set all styles affecting dimensions to default.
            element.css({
                'height': 'auto',
                'max-height': 'none',
                'min-height': '0',
                'width': 'auto',
                'max-width': 'none',
                'min-width': '0'
            });
        }

        // if the element is not hidden, just return its dimensions.
        if (display && display !== 'none') {
            var rect = element[0].getBoundingClientRect(),
                dimensions = {
                    height: rect.height,
                    width: rect.width,
                    innerHeight: isBorderbox ? rect.height :
                        rect.height - borderTop - borderBottom - paddingTop - paddingBottom,
                    innerWidth: isBorderbox ? rect.width :
                        rect.width - borderLeft - borderRight - paddingLeft - paddingRight
                };

        } else {
            // cache any inline styles so they can be restored later.
            var originalStyles = {
                    visibility: element[0].style.visibility,
                    position: element[0].style.position,
                    display: element[0].style.display
                },
            // temp styles for displaying the element.
                tmpStyles = {
                    visibility: 'hidden',
                    display: 'block'
                };

            // set absolute so nothing jumps when displaying the element.
            if (originalStyles.position !== 'fixed') {
                tmpStyles.position = 'absolute';
            }

            // display the element so we can get its dimensions.
            element.css(tmpStyles);

            rect = element[0].getBoundingClientRect();
            dimensions = {
                height: rect.height,
                width: rect.width,
                innerHeight: isBorderbox ? rect.height :
                    rect.height - borderTop - borderBottom - paddingTop - paddingBottom,
                innerWidth: isBorderbox ? rect.width :
                    rect.width - borderLeft - borderRight - paddingLeft - paddingRight
            };

            // restore its original styles.
            element.css(originalStyles);
        }

        if (natural) {
            // set all the style back like they were.
            element.css(natural_dim);
        }

        return dimensions;
    };
});

